import { DataSubject } from '@main/datamap-types';
import type { ID } from '@main/schema-utils';
import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { DataSubjectListItem } from './DataSubjectListItem';
import { HeaderWrapper, ListWrapper, SubjectsListWrapper } from './wrappers';

/**
 * Select DataSubject props
 */
export interface DataSubjectListProps {
  /** Whether it's loading or not */
  loading?: boolean;
  /** The header message for the component */
  headerMessage?: MessageDescriptor;
  /** List of possible Data Subjects */
  value: DataSubject[];
  /** The active data subject */
  activeDataSubjectId?: ID<'subject'>;
  /** creates onClick handler for each subject */
  onSelect: (dataSubject: DataSubject) => void;
}

/**
 * Select what type of data subject is making the request
 */
export function DataSubjectList({
  headerMessage,
  value,
  activeDataSubjectId,
  onSelect,
}: DataSubjectListProps): JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <ListWrapper>
      {headerMessage && (
        <HeaderWrapper>{formatMessage(headerMessage)}</HeaderWrapper>
      )}
      <SubjectsListWrapper>
        {value.map((subject) => (
          <DataSubjectListItem
            key={subject.id}
            subject={subject}
            active={subject.id === activeDataSubjectId}
            onClick={() => onSelect(subject)}
          />
        ))}
      </SubjectsListWrapper>
    </ListWrapper>
  );
}
